import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["provider", "location", "fallback"]
  connect() { this.toggle() }
  toggle() {
    const selected = this.providerTargets.find(input => input.tagName === "SELECT" || input.checked)?.value || ""
    this.locationTarget.hidden = selected !== ""
    if (this.hasFallbackTarget) this.fallbackTarget.hidden = selected !== "zoom"
  }
}
